export default __webpack_public_path__ + "static/media/small.f06c5076.jpg";